import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

/**
 * Parse a template string in the format {{source: schemaId, value: path, type: block}}
 *
 * @param templateString The template string to parse
 * @returns Object with source, value and type properties, or null if string doesn't match pattern
 */
export function parseHandlebarsTemplate(templateString: string): { source: string; value: string; type: string } | null {
    const templatePattern = /\{\{source:\s*([^,]+),\s*value:\s*([^,]+),\s*type:\s*([^}]+)\}\}/
    const matches = templateString.match(templatePattern)

    if (matches) {
        const [_, source, value, type] = matches
        return {
            source: source.trim(),
            value: value.trim(),
            type: type.trim(),
        }
    }

    return null
}

/**
 * Generate a handlebars template string in the format {{source: schemaId, value: path, type: block}}
 *
 * @param source The source schema ID
 * @param value The value path
 * @param type The type (usually 'block')
 * @returns Formatted template string
 */
export function generateHandlebarsTemplate(source: string, value: string, type: string = 'block'): string {
    return `{{source: ${source}, value: ${value}, type: ${type}}}`
}
